export default __webpack_public_path__ + "static/media/3020_unfolded.975ddb6c.jpg";